export interface ProjectPutRequest {
  id: number;
  projectNumber: string;
  projectName: string;
  clientName: string;
  startDate: string;
  endDate: string;
  isUnproductive: boolean;
  isDairen: boolean;
}

export const EmptyProjectPutRequest: ProjectPutRequest = {
  id: 0,
  projectNumber: '',
  projectName: '',
  clientName: '',
  startDate: '',
  endDate: '',
  isUnproductive: false,
  isDairen: false,
};
